module.exports = __webpack_public_path__ + "img/Yellow.33ddd247.jpg";